import React from "react";
import { connect } from "react-redux";

import { st, List, Image, Button } from "lib/index";

export default class CompanyMembersList extends React.PureComponent {
  render() {
    const { members, currentUserId, onMemberClick } = this.props;

    return (
      <List divided relaxed selection>
        {members.map((member) => {
          const canEdit = st.authorize("update", member) && member.admin_user.id !== currentUserId;
          return (
            <List.Item key={member.uuid} disabled={!canEdit} onClick={canEdit && ((event) => onMemberClick(member))}>
              {canEdit && (
                <List.Content floated="right">
                  <Button as="a">{I18n.t("papp.common.manage")}</Button>
                </List.Content>
              )}

              <Image avatar src="/images/placeholder-user.png" />
              <List.Content>
                <List.Header>
                  {member.admin_user.full_name} ({member.admin_user.email})
                </List.Header>
                {member.role_i18n}
              </List.Content>
            </List.Item>
          );
        })}
      </List>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/CompanyMembersView/CompanyMembersList.jsx